import { Add } from "@mui/icons-material";
import { Button, IconButton, Menu, MenuItem, SxProps, Theme, Tooltip } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

interface IKeydriveMenu<T> {
    options: T[];
}

 interface IKeydriveMenuAction {
    titleButton: string;
    idButton?: string;
    disabledButton?: boolean;
    disabledTooltipTitle?: string;
    idMenu?: string;
    startIcon?: React.ReactNode;
    endIcon?: React.ReactNode;
    menuItems: IMenuItemAction[];
    sxButton?: SxProps<Theme> | undefined;
    sxMenu?: SxProps<Theme> | undefined
    sxMenuItems?: SxProps<Theme> | undefined;
    onClose?: () => void;
}

export interface IMenuItemAction {
    key: string;
    text: string;
    onClick: () => void;
    src?: string;
    icon?: React.ReactElement;
    disabled?: boolean;
    sx?: SxProps<Theme> | undefined
}

function KeydriveMenuAction({
    titleButton,
    idButton = "keydrive-menu-button",
    idMenu = "keydrive-menu",
    startIcon,
    endIcon,
    menuItems,
    sxButton,
    sxMenu,
    sxMenuItems,
    disabledButton = false,
    disabledTooltipTitle,
    onClose
}: IKeydriveMenuAction) {
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
            const open = Boolean(anchorEl);
            const handleClick = (event: React.MouseEvent<HTMLElement>) => {
                setAnchorEl(event.currentTarget);
            };
            const handleClose = () => {
                setAnchorEl(null);
                onClose?.();
            };

    const shouldShowDisabledTooltip = disabledButton && disabledTooltipTitle;

    const actionButton = (
        <Button
            disabled={disabledButton}
            sx={sxButton}
            id={idButton}
            aria-controls={open ? idMenu : undefined}
            aria-haspopup="true"
            aria-expanded={open ? 'true' : undefined}
            variant="contained"
            disableElevation
            onClick={handleClick}
            startIcon={startIcon}
            endIcon={endIcon}
        >

            {titleButton}
        </Button>
    );

    return (
        <>
            {
                shouldShowDisabledTooltip
                    ? (
                        <Tooltip title={disabledTooltipTitle!}>
                            <span style={{ display: "inline-flex" }}>
                                {actionButton}
                            </span>
                        </Tooltip>
                    )
                    : actionButton
            }
            <Menu
                id={idMenu}
                MenuListProps={{
                    'aria-labelledby': idButton,
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                sx={sxMenu}
                slotProps={{
        paper: {
            sx: {
                width: anchorEl?.clientWidth
            }
        }
    }}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                }}
            >
                {
                    menuItems.map(item => (
                        <MenuItem
                            key={item.key}
                            disabled={item.disabled}
                            sx={sxMenuItems} 
                            onClick={() => { item.onClick(); handleClose(); }} 
                            disableRipple>
                                {item.src && <img src={item.src} width={20} height={20} style={{ marginRight: '5px' }} />}
                                {item.icon && <span style={{ marginRight: '5px' }}>{item.icon}</span>}
                            {t(item.text)}
                        </MenuItem>
                    ))
                }
            </Menu>
        </>
    )
}

export default KeydriveMenuAction;